import React from 'react';
import "./WarenkorbProdukt.css";

function WarenkorbProdukt() {
    return (
        <div className="warenkorb_produkt">
            
        </div>
    )
}

export default WarenkorbProdukt
